var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { attrs: { label: _vm.i18nt("designer.setting.wordBreak") } },
    [
      _c("el-switch", {
        model: {
          value: _vm.optionModel.wordBreak,
          callback: function ($$v) {
            _vm.$set(_vm.optionModel, "wordBreak", $$v)
          },
          expression: "optionModel.wordBreak",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }